import { render, staticRenderFns } from "./BoxOptions.vue?vue&type=template&id=049a6813&lang=pug&"
import script from "./BoxOptions.vue?vue&type=script&lang=js&"
export * from "./BoxOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports